
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "./combos.css";

/* ----------------- SINGLE IMAGE CARD ------------------ */
const ImageCard = ({ src }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: 10,
        outline: "none",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          height: 260,
          width: "100%",
          borderRadius: 16,
          overflow: "hidden",
          boxShadow: hovered
            ? "0 16px 30px rgba(0,0,0,0.25)"
            : "0 10px 20px rgba(0,0,0,0.15)",
          transition: "all .3s ease",
          transform: hovered ? "translateY(-4px)" : "translateY(0)",
        }}
      >
        <img
          src={src}
          alt="gallery"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transform: hovered ? "scale(1.06)" : "scale(1)",
            transition: "transform .4s ease",
          }}
        />
      </div>
    </div>
  );
};

/* ----------------- MAIN COMPONENT ------------------ */
const GalleryCards = () => {
  const [vendorId, setVendorId] = useState(null);
  const [images, setImages] = useState([]);

  // Read vendor ID
  useEffect(() => {
    setVendorId(localStorage.getItem("vendorId"));
  }, []);

  const toSrc = (raw) => {
    if (!raw) return null;
    if (raw.startsWith("data:") || raw.startsWith("http")) return raw;

    if (raw.includes(".")) {
      const HOST = "http://10.10.20.9:6300";
      return raw.startsWith("/") ? HOST + raw : `${HOST}/${raw}`;
    }

    return `data:image/jpeg;base64,${raw}`;
  };

  // Fetch images
  useEffect(() => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken");

    (async () => {
      try {
        const { data } = await axios.get(
          ` https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const imgs = [data.image1, data.image2, data.image3, data.image4]
          .filter(Boolean)
          .map(toSrc);

        setImages(imgs);
      } catch (err) {
        console.error("Gallery load error:", err);
      }
    })();
  }, [vendorId]);

  /* ----------------- SLICK SLIDER SETTINGS ------------------ */
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 3, // 👉 Only 3 cards visible now
    slidesToScroll: 1,
    pauseOnHover: true,

    responsive: [
      {
        breakpoint: 1024, // tablet large
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768, // tablets
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480, // mobile
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section
      className="gallery-conter-data"
      style={{
        margin: "0 auto",
        padding: "35px 20px",
        maxWidth: "1000px",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          fontSize: 34,
          fontWeight: "900",
          // textTransform: "uppercase",
          marginBottom: 30,
          letterSpacing: "2px",
        }}
      >
        <span style={{ color: "red" }}>Gall</span>
        <span style={{ color: "rgb(42 9 71)" }}>ery</span>
      </h1>

      <Slider {...settings}>
        {images.map((src, idx) => (
          <ImageCard key={idx} src={src} />
        ))}
      </Slider>
    </section>
  );
};

export default GalleryCards;
